<div>
  <cap-haengige-geschaefte-auftraege-icp [hasRight]="hasRight" [perimeter]="grundstueckIds" class="haengige-geschaefte">
  </cap-haengige-geschaefte-auftraege-icp>
</div>
